var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.stateIcon)?_c('IconButton',_vm._g(_vm._b({directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"title":_vm.theTitle,"icon":_vm.stateIcon,"variant":_vm.variant}},'IconButton',_vm.$attrs,false),_vm.$listeners)):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }